import React from "react";

import type { AppConfig } from "~/lib/types";

export const AppConfigContext = React.createContext<AppConfig>({});
